import { Component, OnInit } from "@angular/core";
import { BaseModalComponent } from "@modals/base-modal/base-modal.component";
import { IMenuItemModel } from "@models/core/menu";
import { FormGroup } from "@angular/forms";
import { MenuService } from "@app/core/menu";
import { take } from "rxjs/operators";
import { catchError, of } from "rxjs";
import { HardFormService } from "@hardcode-kz/ui";
import { MenuItemConfig } from "@configs/interface-management/menu-item.config";

@Component({
  selector: "ui-menu-item-modal",
  templateUrl: "./ui-menu-item-modal.component.html",
  styleUrl: "./ui-menu-item-modal.component.scss",
  standalone: false,
})
export class UIMenuItemModalComponent
  extends BaseModalComponent<
    UIMenuItemModalComponent,
    { menuId: string; value?: IMenuItemModel; slug: string }
  >
  implements OnInit
{
  config = new MenuItemConfig();
  form: FormGroup;
  loading = true;

  constructor(
    private menuService: MenuService,
    private formConstructor: HardFormService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data.value) {
      this.menuService
        .getMenuItem(this.data.menuId, this.data.value.id)
        .pipe(
          take(1),
          catchError(() => of(null)),
        )
        .subscribe((response) => {
          if (response) {
            this.createForm(response.value);
          } else {
            this.loading = false;
          }
        });
    } else {
      this.createForm();
    }
  }

  createForm(value?: IMenuItemModel): void {
    this.form = this.formConstructor.buildReactiveForm(this.config.fields);

    if (value) {
      this.form.patchValue({
        ...value,
        ...{
          slug: this.data.slug,
          parent: { id: value?.parentId, name: value?.parentName },
        },
      });
    } else {
      this.form.patchValue({ ...{ slug: this.data.slug } });
    }

    this.loading = false;
  }

  save() {
    if (this.loading) return;

    this.loading = true;

    const data = this.config.saveCallback(this.form.getRawValue());
    const operation = this.data?.value?.id
      ? this.menuService.updateMenuItem(
          { ...data, ...{ menuId: this.data.menuId } },
          this.config.version,
        )
      : this.menuService.createMenuItems(
          this.data.menuId,
          { ...data, ...{ menuId: this.data.menuId } },
          this.config.version,
        );

    operation
      .pipe(
        take(1),
        catchError(() => of(null)),
      )
      .subscribe((response) => {
        if (response) {
          this.dialogRef.close(true);
        }

        this.loading = false;
      });
  }
}
